import { Component, OnInit,ViewChild, ElementRef, NgZone } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ConfirmationService } from 'primeng/api';
import { AppBreadcrumbService } from 'src/app/app.breadcrumb.service';
import { AlertService } from 'src/app/services/AlertService';
import { MemberService } from 'src/app/services/MemberService';
import { MapsAPILoader } from '@agm/core';
import { environment } from 'src/environments/environment';
import { ValidateformComponent } from 'src/app/common/validateform/validateform.component';
import { NgForm } from '@angular/forms';
@Component({
  selector: 'app-memberterritory-edit',
  templateUrl: './memberterritory-edit.component.html',
  styleUrls: ['./memberterritory-edit.component.scss']
})
export class MemberterritoryEditComponent implements OnInit {

  member:any; 
  territories: any;
  addTerritoryDialogVisible: boolean
  addTerritoryDialogMessage : any
  latitude: number;
  longitude: number;
  zoom: number;
  address: string;
  kmlurl: string;
 
  @ViewChild('f', { static: true }) territoryAddForm: NgForm;
  @ViewChild(ValidateformComponent, { static: true }) private formValidator: ValidateformComponent;

 
   granularityLevels = [{label: 'Country Region', value: 1 },{ label: 'State', value: 2 },{ label: 'County', value: 3 }];
   countryOptions: any; 
   territory:any = {Address: "", CountryCode:"", Level:"" }; 
   @ViewChild('searchArea')
  public searchElementEditRef: ElementRef;
  private geoCoder;

  constructor(private breadcrumbService: AppBreadcrumbService,
    private activatedRoute: ActivatedRoute,    
    private memberservice: MemberService,
    private alertService: AlertService,   
    private confirmationService: ConfirmationService,
    private mapsAPILoader: MapsAPILoader,
    private ngZone: NgZone) { }

ngOnInit(): void {
    this.member = this.activatedRoute.snapshot.data['member'];    
    this.territories =this.activatedRoute.snapshot.data['territories'];

    let options = this.activatedRoute.snapshot.data['options'];
    this.countryOptions = new Array(); 
    for (let o of options[0]) {
        let l = o.Name; 
        this.countryOptions.push( {label:l, value:o.Code }); 
    }

    this.breadcrumbService.setItems([      
        { label: this.member.Name, routerLink: ['member/' + this.member.Id] },
        { label: 'Territories', routerLink: [] }
    ]);
    this.InitMap();    
}

  InitMap() {     
    this.mapsAPILoader.load().then(() => {
      this.setCurrentLocation();
      this.geoCoder = new google.maps.Geocoder;
      this.kmlurl =   environment.kmlBase.concat('/TerritoryKML/', this.member.Id,'.kml?t=', Date.now().toString());   
      let autocomplete = new google.maps.places.Autocomplete(this.searchElementEditRef.nativeElement);
      autocomplete.addListener("place_changed", () => {
        this.ngZone.run(() => {
          let place: google.maps.places.PlaceResult = autocomplete.getPlace();

          if (place.geometry === undefined || place.geometry === null) {
            return;
          }
          this.territory.Address = place.formatted_address;
          this.latitude = place.geometry.location.lat();
          this.longitude = place.geometry.location.lng();         
          this.zoom = 12;
        });
      });
    });
  }

    

  deleteterritory(territory) {
    this.confirmationService.confirm({
        message: 'Are you sure you want to remove this territory from this member?',
        accept: () => {
            this.memberservice.DeleteMemberTerritory(this.member.Id, territory.MemberTerritoryID).subscribe(
                result => {
                    if (result) {
                        this.territories = this.territories.filter(val => val.MemberTerritoryID != territory.MemberTerritoryID);
                       
                        this.alertService.SetMessage('success', 'Territory is removed. Note: The map may take several minutes to update.');
                    }
                    else {
                        this.alertService.SetMessage('error', 'There is an error while removing territory');
                    }
                },
                error => {
                    this.alertService.SetMessage('error', 'There is an error while removing territory');
                }
            );      
        }
    });    
  }
  addterritory() {
   
    if (this.formValidator.validateForm())
    {
      if(this.territory.Address == null || this.territory.Address == '')
      {     
        this.alertService.SetMessage('warn', 'Area is required');
      }
      else{      
    
        this.memberservice.InsertMemberTerritory(this.member.Id, this.territory.Address, this.territory.CountryCode, this.territory.Level).subscribe(
          result => {
              if (result.MemberTerritoryID != null && result.MemberTerritoryID != 0) {
                  this.territories.push(result);
                  this.territories.sort((a, b) => (a.MemberTerritoryID > b.MemberTerritoryID ? 1 : -1));            
                  this.alertService.SetMessage('success', 'Territory is added. Note: The map may take several minutes to update. Please check back later.');                                    
              }
              else {
                  this.alertService.SetMessage('error', 'There is an error while adding Territory');
              }
          },
          error => {
              this.alertService.SetMessage('error', 'There is an error while adding Territory');
          }
        );
      }
    }
  }

  private setCurrentLocation() {
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition((position) => {
        this.latitude = position.coords.latitude;
        this.longitude = position.coords.longitude;
        this.zoom = 8;
        this.getAddress(this.latitude, this.longitude);
      });
    }
  }
  
  getAddress(latitude, longitude) {
    this.geoCoder.geocode({ 'location': { lat: latitude, lng: longitude } }, (results, status) => {
      if (status === 'OK') {
        if (results[0]) {
          this.zoom = 12;
          this.address = results[0].formatted_address;
        } else {
          window.alert('No results found');
        }
      } else {
        window.alert('Geocoder failed due to: ' + status);
      }
  
    });
  }
}
